/* eslint no-unused-vars:0 */
import styled from 'styled-components';

export default styled.div`
  overflow-y: ${({ isInviteReflow }) => isInviteReflow ? 'auto' : 'visible'};
  width: 100%;
  font-size: 16px;
  font-size: 1rem;
  color: #6b7588;
  overflow-x: visible;
  height: 100%;
  font-family: Helvetica, Arial, sans-serif;
  padding: 0;
  margin: 0;
  background: #f7f7f8;
  -webkit-font-smoothing: antialiased;
  direction: ${({ isRTL }) => isRTL ? 'rtl' : 'ltr'};
  visibility: ${({ isMobileSmallInvite, isLoadingMobileShortInvite }) => isMobileSmallInvite
    && isLoadingMobileShortInvite ? 'hidden' : 'visible'};
  ${({ isMobileSmallInvite }) => isMobileSmallInvite && `
    height: unset;
    overflow: auto;
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: stretch;
  `};
`;
